import { Dispatch } from 'redux';

// Utils
import getEndpoint from '../../utils/endpoints';
import { fetchWithInterceptors } from 'utils/interceptors';

function maintenancePageSuccess(data: any) {
  return {
    type: 'page/MAINTENANCE_PAGE_SUCCESS' as const,
    data,
  };
}

function maintenancePageFailure(error: unknown) {
  return {
    type: 'page/MAINTENANCE_PAGE_FAILURE' as const,
    error,
  };
}

function maintenanceLoading() {
  return {
    type: 'page/MAINTENANCE_LOADING' as const,
  };
}

export function fetchMaintenancePage(lang: string) {
  const unifiedLang = lang.replace('-', '_').toUpperCase();
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const state = getState();
    const endpoint = `${getEndpoint('maintenance', state)}?lang=${unifiedLang}`;
    dispatch(maintenanceLoading());
    try {
      const response = await fetchWithInterceptors(endpoint);
      const data = await response.json();
      dispatch(maintenancePageSuccess(data));
    } catch (e) {
      dispatch(maintenancePageFailure(e));
    }
  };
}

export type MaintenanceAction =
  | ReturnType<typeof maintenancePageSuccess>
  | ReturnType<typeof maintenancePageFailure>
  | ReturnType<typeof maintenanceLoading>;
